import type { UserProfileUpdateRequestPreferencesTheme } from './userProfileUpdateRequestPreferencesTheme';

export type UserProfileUpdateRequestPreferences = {
  emailNotifications?: boolean;
  language?: string;
  theme?: UserProfileUpdateRequestPreferencesTheme;
};
